<template>
  <div id="index" class="index">
    <div style="display: flex;align-items: center;justify-content: space-between;">
      <div class="Address-Tab">
        <div v-for="(item, index) in tabList" :key="index"
          :class="['Address-Details', { active: selectNumber == index }]" @click="clickType(index)">
          {{ item.title }}
        </div>
      </div>
      <div>
        <el-button type="primary" @click="addressAdd"> 新 增 </el-button>
      </div>
    </div>
    <div class="table-main">
      <Table :addrType="selectNumber" ref="Table" />
    </div>
    <AddressEdit ref="AddressEdit" v-show="isAddressEdit" :isShow="isAddressEdit" @refresh="refresh" @close="refresh" />
  </div>
</template>

<script>
import Table from './Table.vue'
import AddressEdit from './addressEdit.vue'
export default {
  components: {
    Table,
    AddressEdit
  },
  props: {
    // 父辈向子辈传参
  },
  data () {
    return {
      tabList: [
        {
          title: '发件人地址库'
        },
        {
          title: '收件人地址库'
        }
      ],
      isAddressEdit: false,
      columeList: [
        {
          field: 'name',
          value: '联系人',
          width: 180,
          fixed: true
        }, {
          field: 'tel',
          value: '电话',
          width: 180,
          fixed: true
        }, {
          field: 'companyName',
          value: '公司名称',
          width: 180,
          fixed: true
        }, {
          field: 'countryName',
          value: '国家',
          width: 180,
          fixed: true
        }, {
          field: 'provinceName',
          value: '省州',
          width: 180,
          fixed: true
        }, {
          field: 'cityName',
          value: '城市',
          width: 180,
          fixed: true
        }, {
          field: 'townName',
          value: '区域',
          width: 180,
          fixed: true
        }, {
          field: 'address',
          value: '联系地址',
          width: 180,
          fixed: true
        }, {
          field: 'zipCode',
          value: '邮编',
          width: 180,
          fixed: true
        }
      ],
      selectNumber: 0
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  mounted () {
    // 页面进入时加载内容
  },
  created () {
    // 实例被创建之后执行代码
    localStorage.removeItem('columeList-address')
    localStorage.setItem('columeList-address', JSON.stringify(this.columeList))
  },
  methods: {
    clickType (index) {
      this.selectNumber = index
      this.$nextTick(() => {
        this.$refs.Table.search();
      })
    },
    addressAdd () {
      this.isAddressEdit = true;
      this.$refs.AddressEdit.init('',this.selectNumber)
    },
    refresh () {
      this.isAddressEdit = false;
      this.$nextTick(() => {
        this.$refs.Table.search();
      })
    }
  }
}
</script>
<style scoped lang="scss">
.Address-Tab {
  display: flex;
  justify-content: start;
  align-items: center;
  width: 256px;
  height: 48px;
  padding: 0 8px;
  background: rgba(221, 221, 221, 0.32);
  border-radius: 8px;
  box-sizing: border-box;

  .Address-Details,
  .Users {
    white-space: nowrap;
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #777777;
    margin-right: 16px;
    line-height: 32px;
    cursor: pointer;
    padding: 0 8px;
    transition: all 0.3s;
  }

  .Users {
    margin-left: 8px;
  }

  .active {
    // max-width: 145px;
    // min-width: 59px;
    height: 32px;
    line-height: 32px;
    background: #ffffff;
    border-radius: 6px;
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #3370ff !important;
  }
  .table-main {
    background: #ffffff;
    border-radius: 8px;
    padding: 24px;
    margin-top: 16px;
  }
}
</style>
